/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Terms_Save_Changes_FailedInputs */

const en_knp_terms_save_changes_failed = /** @type {(inputs: Knp_Terms_Save_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save some changes: ${i?.error}`)
};

const fr_knp_terms_save_changes_failed = /** @type {(inputs: Knp_Terms_Save_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’enregistrement de certaines modifications : ${i?.error}`)
};

const de_knp_terms_save_changes_failed = /** @type {(inputs: Knp_Terms_Save_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Einige Änderungen konnten nicht gespeichert werden: ${i?.error}`)
};

const it_knp_terms_save_changes_failed = /** @type {(inputs: Knp_Terms_Save_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile salvare alcune modifiche: ${i?.error}`)
};

const ru_knp_terms_save_changes_failed = /** @type {(inputs: Knp_Terms_Save_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось сохранить некоторые изменения: ${i?.error}`)
};

const es_knp_terms_save_changes_failed = /** @type {(inputs: Knp_Terms_Save_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudieron guardar algunos cambios: ${i?.error}`)
};

const zh_cn2_knp_terms_save_changes_failed = /** @type {(inputs: Knp_Terms_Save_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`部分更改保存失败：${i?.error}`)
};

const ja_knp_terms_save_changes_failed = /** @type {(inputs: Knp_Terms_Save_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`一部の変更を保存できませんでした: ${i?.error}`)
};

const hi_knp_terms_save_changes_failed = /** @type {(inputs: Knp_Terms_Save_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कुछ परिवर्तन सहेजने में विफल: ${i?.error}`)
};

const pt_pt2_knp_terms_save_changes_failed = /** @type {(inputs: Knp_Terms_Save_Changes_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao salvar algumas alterações: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to save some changes: {error}" |
*
* @param {Knp_Terms_Save_Changes_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_save_changes_failed = /** @type {((inputs: Knp_Terms_Save_Changes_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Save_Changes_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_save_changes_failed(inputs)
	if (locale === "de") return de_knp_terms_save_changes_failed(inputs)
	if (locale === "it") return it_knp_terms_save_changes_failed(inputs)
	if (locale === "ru") return ru_knp_terms_save_changes_failed(inputs)
	if (locale === "es") return es_knp_terms_save_changes_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_save_changes_failed(inputs)
	if (locale === "ja") return ja_knp_terms_save_changes_failed(inputs)
	if (locale === "hi") return hi_knp_terms_save_changes_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_save_changes_failed(inputs)
	return en_knp_terms_save_changes_failed(inputs)
});